import { cardListStyles } from "@insite/content-library/Components/CardList";
import { baseGridItemGridProps } from "@store/theme/common/props/baseGrid";

Object.assign(cardListStyles, {
    gridContainer: baseGridItemGridProps.container,
});
